<div class="app-studies-table-wrapper">
  <app-error-snack-bar [message]="message"></app-error-snack-bar>
  <app-studies-table-filters
    [(year)]="year"
    [(month)]="month"
    [(customer)]="customer"
    [(customerLawFirm)]="customerLawFirm"
    [(selectFilters)]="currentSelectFilters"
    [searchLabels]="searchLabels"
    [(searchText)]="searchText"
    [(searchLabel)]="searchLabel"
    (filterChanged)="filterChanged()"
    (searchTextLabelChange)="searchTextLabelChanged()"
  ></app-studies-table-filters>
  <app-studies-table-pagination
    [length]="count"
    [pageIndex]="studiesPageIndex"
    (handlePageEvent)="handlePageEvent($event)"
  ></app-studies-table-pagination>
  <app-studies-table
    [columns]="tableColumns"
    [loading]="loading"
    [studies]="studies"
    [sortDirection]="sortDirection"
    (sortChange)="handleSortEvent($event)"
  ></app-studies-table>
</div>
